var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelCircle = function SvgCancelCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E85C4A",
    d: "M10.6 12.0004L6.30005 7.80039L7.70005 6.40039L11.9 10.6004L16.1 6.40039L17.5 7.80039L13.4 12.0004L17.6 16.2004L16.2001 17.6004L12 13.4004L7.80005 17.6004L6.40005 16.2004L10.6 12.0004Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E85C4A",
    d: "M19.3523 19.4267C15.1544 23.6317 8.41821 23.6317 4.12266 19.4267C-0.172892 15.2216 -0.0752664 8.47392 4.12266 4.17105C8.32058 -0.131814 15.0568 -0.0340221 19.3523 4.17105C23.6479 8.37612 23.5503 15.2216 19.3523 19.4267ZM5.48943 5.54014C2.07251 8.96288 2.07251 14.537 5.48943 17.9598C8.90634 21.3825 14.471 21.3825 17.8879 17.9598C21.3049 14.537 21.3049 8.96288 17.8879 5.54014C14.471 2.11741 9.00397 2.11741 5.48943 5.54014Z"
  })));
};
export default SvgCancelCircle;